import React from "react";
import Image from "next/image";
import styles from "./CaseStudyHoverCard.module.css";

const CaseStudyHoverCard = ({
  logo,
  company,
  quote,
  name,
  title,
  avatar,
  className = "",
}) => {
  return (
    <div
      className={`bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ${styles.fadeScaleIn} ${className}`}
      style={{ pointerEvents: "auto" }}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0">
          <Image src={logo} alt={company} fill className="object-contain" />
        </div>
        <span className="font-semibold text-gray-900 text-base">{company}</span>
      </div>
      <blockquote className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic">
        {quote}
      </blockquote>
      <hr className="my-3 border-gray-100" />
      <div className="flex items-center gap-3 mt-3">
        <div className="relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0">
          <Image
            src={
              avatar ||
              `https://avatar.iran.liara.run/public/boy?username=${name}`
            }
            alt={name}
            fill
            className="object-cover"
          />
        </div>
        <div>
          <div className="font-semibold text-gray-900 text-xs">{name}</div>
          <div className="text-gray-500 text-[10px] mt-0.5">{title}</div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyHoverCard;
